export default "__VITE_ASSET__WcKb8_SW__"